import { ChangeDetectionStrategy, Component, ViewEncapsulation, forwardRef, input, output } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { CheckboxConfig } from "./checkbox.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { CheckboxModule } from "primeng/checkbox";
import { V_FORM_CONTROL_TOKEN, V_SKIP_REGISTER, WRAPPER_TOKEN } from "../wrapper.tokens";
import { GcLayoutModule } from "src/app/components/v-layout/layout.module";
import { TranslateModule } from "@ngx-translate/core";

/**
 * @type TValue: type or union `TValue = true | false`
 */
@Component({
    selector:      'v-checkbox',
    templateUrl:   './checkbox.component.haml',
    styleUrls:     ['./checkbox.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VCheckboxComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VCheckboxComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VCheckboxComponent), multi: true },
        { provide: V_SKIP_REGISTER, useValue: false },

    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, CheckboxModule, ReactiveFormsModule, SharedModule, GcLayoutModule, TranslateModule]
})
export class VCheckboxComponent<TValue = unknown> extends InputFormWrapper<CheckboxConfig, unknown> {
    protected readonly _baseConfig: CheckboxConfig = CheckboxConfig.baseTheme.Default;

    public name? = input<string>();
    public inputValue? = input<TValue>(undefined, { alias: 'value' });
    public trueValue? = input<TValue>(true as TValue);
    public falseValue = input<TValue | null | undefined>(false as TValue);
    public checked = output<boolean>();

    onChecked(event: {checked?: unknown | unknown[]}) {
        const trueValue = (this.inputValue() ?? this.trueValue() ?? true);
        const isChecked = this.config().binary ? event.checked === trueValue : (event.checked as unknown[]).includes(trueValue);
        this.checked.emit(isChecked);
    }

    get isChecked(): boolean {
        return this.control.value === this.trueValue();
    }
}